import { render, staticRenderFns } from "./studentProfileCard.vue?vue&type=template&id=8a65a302&scoped=true&"
import script from "./studentProfileCard.vue?vue&type=script&lang=js&"
export * from "./studentProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./studentProfileCard.vue?vue&type=style&index=0&id=8a65a302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a65a302",
  null
  
)

export default component.exports